
import { Vue, Component } from 'vue-property-decorator';
import NavLogo from '@/features/common/components/navbar/NavLogo.vue';
import TermsTopPanel from '@/features/terms-and-conditions/components/TermsTopPanel.vue';
import TermsForm from '@/features/terms-and-conditions/components/TermsForm.vue';
import { TermsDetails } from '@/features/terms-and-conditions/types';
import { showErrorAlertDialog } from '@/features/common/helpers';
import { fetchTermsDetails, acceptTerms, remindLater } from '@/features/terms-and-conditions/services/terms.services';
import router from '@/router';

@Component({
  components: {
    NavLogo,
    TermsTopPanel,
    TermsForm,
  },
})
export default class Terms extends Vue {
  private termsDetails: TermsDetails | null = null;

  private isLoading = false;

  private isRemindLaterLoading = false;

  get terms(): string {
    return this.termsDetails?.terms || '';
  }

  private async created(): Promise<void> {
    this.$store.commit('setLoading', true);

    this.termsDetails = await fetchTermsDetails();

    this.$store.commit('setLoading', false);
  }

  private printTerms = (): void => {
    window.print();
  }

  private async submit() {
    this.isLoading = true;
    const termsAccept = await acceptTerms();
    this.isLoading = false;

    if (!termsAccept?.accepted) {
      showErrorAlertDialog();
      return;
    }

    const { redirectUrl } = this.$route.query;

    if (redirectUrl) {
      const redirectUrlWithoutShip = (redirectUrl as string).replace(/(\/ship){2,}/g, '/ship');
      router.replace(redirectUrlWithoutShip);
      return;
    }

    window.location.replace(process.env.VUE_APP_ORIGIN || '/');
  }

  private async remindLater() {
    this.isRemindLaterLoading = true;
    try {
      await remindLater(this.termsDetails?.version || 0);
      window.location.replace(process.env.VUE_APP_ORIGIN || '/');
    } catch {
      showErrorAlertDialog();
    }

    this.isRemindLaterLoading = false;
  }
}
